// src/features/projects/components/ProjectAchievements.tsx

import React from 'react';
import styles from './ProjectAchievements.module.scss';
import { Achievement } from '../types/project';
import SpotlightCard from './SpotlightCard';

interface ProjectAchievementsProps {
  achievements: Achievement[];
}

const ProjectAchievements: React.FC<ProjectAchievementsProps> = ({ achievements }) => {

  if (!achievements || achievements.length === 0) return null;

  return (
    <section className={styles.achievementsSection}>
      <div className={styles.achievementsContainer}>
        {achievements.map((ach, idx) => (
          <SpotlightCard
            key={idx}
            className={styles.achievementCard}
            /* Try a subtle or brand color for the highlight */
          >
            <div className={styles.value}>{ach.value}</div>
            <div className={styles.label}>{ach.label}</div>
            <p className={styles.description}>{ach.description}</p>
          </SpotlightCard>
        ))}
      </div>
    </section>
  );
};

export default ProjectAchievements;